import { useMemo } from 'react';

export const useIsBirthday = (personNumber?: string) => {
  return useMemo(() => {
    if (!personNumber || personNumber.length < 8) return false; // Safety check

    const today = new Date();
    const month = (today.getMonth() + 1).toString().padStart(2, '0');
    const day = today.getDate().toString().padStart(2, '0');
    const formattedMonthAndDay = `${month}${day}`;

    return formattedMonthAndDay === personNumber.slice(4, 8); // Korrekt jämförelse
  }, [personNumber]);
};
